import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { FormikProps } from 'formik'

import AlertBase from 'components/Alert'
import { Error, File } from 'components/Input'

import Step from './Step'
import { Group } from './styles'
import { FormValue } from './types'
import { ALLOWED_FILETYPES, SUPPORT_EMAIL } from '../../../constants'
import { validateLanesFile } from 'services/rfp'

const Alert = styled(AlertBase)`
  width: 100%;
`

interface Props {
  formikProps: FormikProps<FormValue>
}

export default function Details({ formikProps }: Props) {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    setTouched,
    handleBlur,
  } = formikProps
  const [isLoading, setLoading] = useState(false)
  const [isInvalid, setInvalid] = useState(false)
  const errorMsg = touched.lanesFile && errors.lanesFile ? errors.lanesFile : ''
  const onChange = useCallback(
    async (file: File | undefined) => {
      setInvalid(false)
      setLoading(true)
      setTouched({ ...touched, lanesFile: true })
      setFieldValue('lanesFile', file)
      if (!file) {
        setLoading(false)
        return
      }

      try {
        await validateLanesFile(file)
      } catch (err) {
        setFieldValue('lanesFile', undefined)
        setInvalid(true)
      } finally {
        setLoading(false)
      }
    },
    [setFieldValue, setTouched, touched]
  )

  return (
    <Step
      title="Upload your lanes file"
      subtitle="Click here to know how to quickly format the file"
    >
      <Group>
        {isInvalid && !isLoading && (
          <Alert type="error">
            <span>
              <b>Looks like the file you&apos;ve chosen is invalid.</b>
              &nbsp;Please reach our support at{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
            </span>
          </Alert>
        )}
        <File
          name="lanesFile"
          onBlur={handleBlur}
          onChange={onChange}
          value={values.lanesFile}
          accept={ALLOWED_FILETYPES}
          error={!!errorMsg}
          isLoading={isLoading}
        />
        {!isLoading && <Error error={errorMsg} />}
      </Group>
    </Step>
  )
}
